const messages = {
    buttons: {
        productBrochures: "Tutustu",
    },
    index: {
        title: "TUOTETIEDOT",
        description: "Lataa täältä uusimmat esitteet ja lentolehtiset Bridgestone- ja Firestone-renkaistamme.",
        categories: {
            productBrochures: {
                title: "Tuoteesitteet",
                description: "Bridgestone- ja Firestone-renkasarjojen esitteet",
            },
            bDrive: {
              title: "Tuotekuvat",
              description: "Ajantasaiset kuvat löydät ladattavaksi B-DRIVE-portaalistamme.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

